<app-donut-chart
  [data]="chartData"
  [labels]="labels"
  [preferredColors]="preferredColors"
></app-donut-chart>
